import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { BsCheckCircle, BsCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import { ShimmerText, ShimmerTitle } from "react-shimmer-effects";
import {
  businessFields,
  buyerFields,
  caBillCaliforniaStateFields,
  caBillHousingCoopFields,
  caBillLandTrustFields,
  caBillNonProfitFields,
  caBillOwnerOccupiedFields,
  californiaStateFields,
  cwcotGovernmentFields,
  cwcotHudNonProfitFields,
  firstLookNonProfitFields,
  firstLookOwnerOccupiedFields,
  governmentEntityFields,
  housingCoopFields,
  hudNonProfitFields,
  landTrustFields,
  nonProfitCorpFields,
  ownerOccupiedFields,
  selfOccupancyFields,
} from "@/components/user/MyBids/Editcif/editcif/EditFormfields";
import {
  cityList,
  isPhoneNoInUse,
  isPhoneNoVerified,
  stateListData,
  validateAddress,
} from "@/api/bid";
import {
  handleBusinessFileDelete,
  handleBusinessFileUpload,
  FILE_TYPES,
  handleCWCOTFileUpload,
  handleCWCOTFileDelete,
  handleCABillFileUpload,
} from "@/components/user/MyBids/Editcif/editcif/fileUploadHandler";
import { useSelector } from "react-redux";
import VerifyPhoneModal from "@/components/bid/VerifyPhoneModal";
import VerificationTick from "../../../../../../public/assets/images/verificationTick.svg";
import VerificationPending from "../../../../../../public/assets/images/verificationPending.svg";
import { BuyerAccordian_icon } from "@/components/bid/WizardIcons";

const EditBuyer = ({
  setCollapseAccordian,
  collapseAccordian,
  selectedDescription,
  buyingForSelf,
  cifData,
  submittedAccordions,
  setSubmittedAccordions,
  isEnabled,
  primaryBuyerData,
  setPrimaryBuyerData,
  setCobuyerData,
  cobuyerData,
  listingId,
  primaryEntityType,
  setPrimaryEntityType,
  setHasCobuyer,
  cobuyerEntityType,
  setCobuyerEntityType,
  hasCobuyer,
  uploadedFiles,
  setUploadedFiles,
  setIsSubmitting,
  isSubmitting,
  mode,
  formState,
  agentData,
  showFirstLookOptions,
  firstLookReadOnly,
}) => {
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

  // States for city/state handling
  // console.log("formstate-----", formState?.llc, formState?.pof);
  const [states, setStates] = useState([]);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [errors, setErrors] = useState({});
  const [isValidating, setIsValidating] = useState(false); // Add this state
  const [fileError, setFileError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUploadingPrimary, setIsUploadingPrimary] = useState(false);
  const [isUploadingCo, setIsUploadingCo] = useState(false);
  const [isDeletingPrimary, setIsDeletingPrimary] = useState(false);
  const [isDeletingCo, setIsDeletingCo] = useState(false);

  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isNumberVerified, setIsNumberVerified] = useState(true);
  const [sentVerificationCode, setSendVerificationCode] = useState({
    message: null,
    showCta: false,
  });
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const primaryFileInputRef = useRef(null);
  const coBuyerFileInputRef = useRef(null);
  const buyerFormRef = useRef({});
  const cobuyerFormRef = useRef({});

  const propertyDetails = cifData?.data?.propertyDetails;

  const editCIFObject = cifData?.data;

  const stateWorkflowEnabled =
    propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL"
      ? false
      : editCIFObject?.isStateWorkflowEnabled === "Y"
      ? true
      : false;

  const isStateWorkflowDurationActive =
    propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL"
      ? false
      : editCIFObject?.isStateWorkflowDurationActive === "Y"
      ? true
      : false;

  const CWCOTUpdateEnabled =
    editCIFObject?.cwcotUpdateEnabled === "Y" &&
    !stateWorkflowEnabled &&
    propertyDetails?.address?.state !== "CA"
      ? true
      : false;

  const CWCOTUpdateValid =
    editCIFObject?.cwcotUpdateValid === "Y" &&
    !stateWorkflowEnabled &&
    propertyDetails?.address?.state !== "CA"
      ? true
      : false;

  const CWCOTCAUpdateEnabled =
    editCIFObject?.cwcotUpdateEnabled === "Y" &&
    !stateWorkflowEnabled &&
    propertyDetails?.address?.state === "CA"
      ? true
      : false;

  const CWCOTCAUpdateValid =
    editCIFObject?.cwcotUpdateValid === "Y" &&
    !stateWorkflowEnabled &&
    propertyDetails?.address?.state === "CA"
      ? true
      : false;

  const [isCWCOTProp, setIsCWCOTProp] = useState(
    propertyDetails?.commonAttributes?.propCategory === "SC" &&
      propertyDetails?.address?.state !== "CA" &&
      CWCOTUpdateEnabled &&
      CWCOTUpdateValid
      ? true
      : false
  );
  const [isCWCOTCAProp, setIsCWCOTCAProp] = useState(CWCOTCAUpdateValid);
  const [isCABillProp, setIsCABillProp] = useState(stateWorkflowEnabled);

  // First Look (SPS 945): seller 945, Bank Owned (REO), non-CA state,
  // First Look flag "Y", and the current date is within the expiry window
  // (from the CIF response propertyDetails, same shape as the PDP property data).
  const isFirstLookActive =
    propertyDetails?.sellerId === "945" &&
    propertyDetails?.commonAttributes?.propCategory === "REO" &&
    propertyDetails?.address?.state !== "CA" &&
    editCIFObject?.firstLook === "Y" &&
    !isCABillProp &&
    !isCWCOTProp &&
    !isCWCOTCAProp;

  // Render the First Look options when the window is active OR (in Edit CIF)
  // when the parent says a saved First Look CIF is being edited after expiry
  // (in which case firstLookReadOnly disables the inputs).
  const isFirstLookProp = showFirstLookOptions ?? isFirstLookActive;

  // const [selectedDocumnetsCat, setSelectedDocumnetsCat] = useState();

  const isSingleFileEntity = (entityType) => {
    const singleFileEntities = [
      "cabillowneroccupied",
      "cabillnonprofit",
      "cabillcaliforniastate",
      "cabilllandtrust",
      "cabillhousingcoop",
      "owneroccupied",
      "nonprofitcorp",
      "landtrust",
      "housingcoop",
      "california",
      "cwcotgovernment",
      // "cabillnonprofit",
    ];
    return singleFileEntities.includes(entityType?.toLowerCase());
  };

  const getDocumnetsForbuyerCategory = () => {
    switch (primaryEntityType) {
      case "selfOccupancy":
        // setSelectedDocumnetsCat("buyerSelfCWCOTFiles");
        return "buyerSelfCWCOTFiles";

      case "government":
        // setSelectedDocumnetsCat("caBuyerGovtCWCOTFiles");
        return "caBuyerGovtCWCOTFiles";

      case "caBillOwnerOccupied":
        // setSelectedDocumnetsCat("caBillOwnerOccupiedFiles");
        return "caBillOwnerOccupiedFiles";

      case "caBillNonProfit":
        // setSelectedDocumnetsCat("caBillNonProfitCorpFiles");
        return "caBillNonProfitCorpFiles";

      case "caBillLandTrust":
        // setSelectedDocumnetsCat("caBillCommunityTrustlandFiles");
        return "caBillCommunityTrustlandFiles";

      case "caBillHousingCoop":
        // setSelectedDocumnetsCat("caBillEquHousingCoFiles");
        return "caBillEquHousingCoFiles";

      case "caBillCaliforniaState":
        // setSelectedDocumnetsCat("caBillStateofCalifornia");
        return "caBillStateofCalifornia";

      case "business":
        // setSelectedDocumnetsCat("caBillStateofCalifornia");
        return "buyerLLCFiles";

      // First Look (SPS 945): behaves like a standard individual buyer — no
      // special doc bucket; falls through to the default primaryBuyer bucket.

      default:
        // setSelectedDocumnetsCat("primaryBuyer");
        return "primaryBuyer";
    }
  };
  const shouldDisablePrimaryUpload =
    isSingleFileEntity(primaryEntityType) &&
    (uploadedFiles[getDocumnetsForbuyerCategory()]?.length > 0 ||
      !isStateWorkflowDurationActive);

  const shouldDisableCoBuyerUpload =
    isSingleFileEntity(cobuyerEntityType) && uploadedFiles.coBuyer.length > 0;

  useEffect(() => {
    fetchStateValues();
  }, []);

  // Fetch cities when state changes for primary buyer
  useEffect(() => {
    if (primaryBuyerData.stateId) {
      fetchCities(primaryBuyerData.stateId);
    }
  }, [primaryBuyerData.stateId]);

  // Fetch cities when state changes for co-buyer
  useEffect(() => {
    if (cobuyerData.stateId) {
      fetchCities(cobuyerData.stateId);
    }
  }, [cobuyerData.stateId]);

  const fetchStateValues = async () => {
    try {
      const data = await stateListData();
      setStates(data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCities = async (stateId) => {
    try {
      const response = await cityList(stateId);
      setAllCities(response?.data?.data || []);
      setCitySuggestions([]);
      setShowSuggestions(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setAllCities([]);
    }
  };

  const handleValidationOnBlur = async (e) => {
    const { name, value } = e.target;
    let errors = {};
    const cleanValue = name === "phone" ? value.replace(/\D/g, "") : value;

    if (name === "phone") {
      const phoneError = validateField(cleanValue, "phone", name);
      if (phoneError) {
        errors[name] = phoneError;
        setSendVerificationCode({
          message: null,
          showCta: false,
        });
        setIsNumberVerified(false);
      } else {
        // ✅ Skip verification if it's Agent + No
        if (!(selectedDescription === "Agent" && buyingForSelf === "No")) {
          phoneNumberVerification(name, value);
        } else {
          // just mark as valid, no verification needed
          setIsNumberVerified(true);
          setSendVerificationCode({
            message: null,
            showCta: false,
          });
        }
      }
    }

    // For all other fields, use validateField
    else {
      const fieldType =
        name === "email" ? "email" : name === "zip" ? "zip" : "text";

      // 💡 Skip middleName validation if empty
      if (name === "middleName" && !value.trim()) {
        return; // ✅ Don't validate or set error
      }

      const error = validateField(value, fieldType, name);
      if (error) {
        errors[name] = error;
      }
    }

    // Update errors state
    setErrors((prev) => ({
      ...prev,
      primaryBuyer: {
        ...prev.primaryBuyer,
        [name]: errors[name],
      },
    }));
  };
  const handleCobuyerValidationOnBlur = (e) => {
    const { name, value } = e.target;
    let errors = {};

    // Use the same fieldType determination
    const fieldType =
      name === "email"
        ? "email"
        : name === "zip"
        ? "zip"
        : name === "phone"
        ? "phone"
        : "text";

    // Use existing validateField function
    const error = validateField(value, fieldType, name);
    if (error) {
      errors[name] = error;
    }

    // Update only cobuyer errors
    setErrors((prev) => ({
      ...prev,
      coBuyer: {
        ...prev.coBuyer,
        [name]: errors[name],
      },
    }));
  };

  const handlePrimaryBuyerChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "phone" && value.length > 10) {
      return;
    }

    // Update form data
    setPrimaryBuyerData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    // Clear specific field error when user starts typing
    setErrors((prev) => ({
      ...prev,
      primaryBuyer: {
        ...prev.primaryBuyer,
        [name]: null,
      },
    }));

    // Handle city suggestions
    if (name === "city" && value.length > 2) {
      const filteredCities = allCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );
      setCitySuggestions(filteredCities);
      setShowSuggestions(true);
    } else if (name === "city") {
      setCitySuggestions([]);
      setShowSuggestions(false);
    }

    // Validate specific fields immediately based on entity type
    if (primaryEntityType === "business" && name === "companyName") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          primaryBuyer: {
            ...prev.primaryBuyer,
            companyName: "Invalid corporation name",
          },
        }));
      }
    }

    // CWCOT and CWCOT-CA specific validations
    if (isCWCOTProp || isCWCOTCAProp) {
      switch (primaryEntityType) {
        case "hudNonProfit":
        case "cwcotHudNonProfit":
          if (name === "organizationName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                organizationName: "Please enter valid Non profit Entity",
              },
            }));
          }
          break;
        case "government":
        case "cwcotGovernment":
          if (name === "governmentEntityName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                governmentEntityName: "Please enter valid governmental entity",
              },
            }));
          }
          break;
        case "nonProfitCorp":
          if (name === "nonProfitCorpName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                nonProfitCorpName: "Please enter valid Non profit Entity",
              },
            }));
          }
          break;
        case "landTrust":
          if (name === "landTrustName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                landTrustName: "Please enter valid community land trust",
              },
            }));
          }
          break;
        case "housingCoop":
          if (name === "housingCoopName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                housingCoopName:
                  "Please enter valid limited equity housing co-operative",
              },
            }));
          }
          break;
        case "ownerOccupied":
          if (name === "ownerOccupiedName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                ownerOccupiedName: "Owner occupied name is required",
              },
            }));
          }
          break;
        case "california":
          if (name === "californiaStateName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                californiaStateName: "California state name is required",
              },
            }));
          }
          break;
      }
    }
    // Add CA Bill specific validations
    if (isCABillProp) {
      switch (primaryEntityType) {
        case "caBillOwnerOccupied":
          if (name === "caBillOwnerOccupiedName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                caBillOwnerOccupiedName:
                  "CA Bill Owner occupied name is required",
              },
            }));
          }
          break;
        case "caBillNonProfit":
          if (name === "caBillNonProfitName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                caBillNonProfitName:
                  "Please enter valid CA Bill Non profit Entity",
              },
            }));
          }
          break;
        case "caBillLandTrust":
          if (name === "caBillLandTrustName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                caBillLandTrustName:
                  "Please enter valid CA Bill community land trust",
              },
            }));
          }
          break;
        case "caBillHousingCoop":
          if (name === "caBillHousingCoopName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                caBillHousingCoopName:
                  "Please enter valid CA Bill limited equity housing co-operative",
              },
            }));
          }
          break;
        case "caBillCaliforniaState":
          if (name === "caBillCaliforniaStateName" && !value.trim()) {
            setErrors((prev) => ({
              ...prev,
              primaryBuyer: {
                ...prev.primaryBuyer,
                caBillCaliforniaStateName:
                  "CA Bill California state name is required",
              },
            }));
          }
          break;
      }
    }
  };

  const validateFile = (file) => {
    if (!file) return "Please select a file";
    if (file.size > MAX_FILE_SIZE) return "File size exceeds 10MB limit";
    return "";
  };

  const handleFileChange = async (event, isCoBuyer = false) => {
    const file = event.target.files[0];
    if (!file) return;

    const error = validateFile(file);
    if (error) {
      setFileError("Maximum file size allowed is 10MB");
      if (isCoBuyer) {
        setIsUploadingCo(false);
      } else {
        setIsUploadingPrimary(false);
      }
      return;
    }

    if (isCoBuyer) {
      setIsUploadingCo(true);
    } else {
      setIsUploadingPrimary(true);
    }
    setFileError("");

    try {
      const currentEntityType = isCoBuyer
        ? cobuyerEntityType
        : primaryEntityType;

      const uploadedDocs =
        uploadedFiles[
          isCoBuyer
            ? "coBuyer"
            : getDocumnetsForbuyerCategory(primaryEntityType)
        ];

      // 🚫 Block multiple uploads for restricted entity types
      if (isSingleFileEntity(currentEntityType) && uploadedDocs.length > 0) {
        return;
      }
      const result =
        isCWCOTProp || isCWCOTCAProp
          ? await handleCWCOTFileUpload(
              file,
              currentEntityType,
              isCoBuyer,
              listingId
            )
          : isCABillProp // Add this condition
          ? await handleCABillFileUpload(
              file,
              currentEntityType,
              isCoBuyer,
              listingId
            )
          : await handleBusinessFileUpload(
              file,
              currentEntityType,
              isCoBuyer,
              listingId
            );
      if (result.success) {
        // Update to append to array instead of replacing
        setUploadedFiles((prev) => ({
          ...prev,

          [isCoBuyer ? "coBuyer" : getDocumnetsForbuyerCategory()]: [
            ...(prev[isCoBuyer ? "coBuyer" : getDocumnetsForbuyerCategory()] ||
              []),
            result.data,
          ],
        }));

        setErrors((prev) => ({
          ...prev,
          [isCoBuyer ? "coBuyer" : "primaryBuyer"]: {
            ...(prev[isCoBuyer ? "coBuyer" : "primaryBuyer"] || {}),
            documents: undefined,
          },
        }));
      } else {
        setFileError(result.error);
      }
    } catch (error) {
      setFileError(error.message || "Error uploading file");
    } finally {
      const fileInput = isCoBuyer ? coBuyerFileInputRef : primaryFileInputRef;
      if (fileInput.current) {
        fileInput.current.value = "";
      }

      if (isCoBuyer) {
        setIsUploadingCo(false);
      } else {
        setIsUploadingPrimary(false);
      }
    }
  };

  const handleFileDelete = async (e, isCoBuyer = false, fileIndex) => {
    e.preventDefault();

    if (isCoBuyer) {
      setIsDeletingCo(true);
    } else {
      setIsDeletingPrimary(false);
    }

    try {
      const files =
        uploadedFiles[
          isCoBuyer
            ? "coBuyer"
            : getDocumnetsForbuyerCategory(primaryEntityType)
        ];

      const fileToDelete = files[fileIndex];

      const result =
        isCWCOTProp || isCWCOTCAProp
          ? await handleCWCOTFileDelete(fileToDelete.documentId, listingId)
          : await handleBusinessFileDelete(fileToDelete.documentId, listingId);

      if (result.success) {
        setUploadedFiles((prev) => ({
          ...prev,
          [isCoBuyer
            ? "coBuyer"
            : getDocumnetsForbuyerCategory(primaryEntityType)]: prev[
            isCoBuyer
              ? "coBuyer"
              : getDocumnetsForbuyerCategory(primaryEntityType)
          ].filter((_, idx) => idx !== fileIndex),
        }));
      } else {
        setFileError(result.error);
      }
    } catch (error) {
      setFileError(error.message || "Error deleting file");
    } finally {
      if (isCoBuyer) {
        setIsDeletingCo(false);
      } else {
        setIsDeletingPrimary(false);
      }
    }
  };

  const handleCobuyerChange = (e) => {
    const { name, value, type, files } = e.target;
    setCobuyerData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // Clear specific field error when user starts typing
    setErrors((prev) => ({
      ...prev,
      coBuyer: {
        ...prev.coBuyer,
        [name]: null,
      },
    }));
    if (name === "city" && value.length > 2) {
      const filteredCities = allCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );
      setCitySuggestions(filteredCities);
      setShowSuggestions(true);
    } else if (name === "city") {
      setCitySuggestions([]);
      setShowSuggestions(false);
    }

    // Validate specific fields immediately
    if (cobuyerEntityType === "business" && name === "companyName") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          coBuyer: {
            ...prev.coBuyer,
            companyName: "Company name is required",
          },
        }));
      }
    }
  };

  const handleSuggestionClick = (suggestion, isCobuyer = false) => {
    if (isCobuyer) {
      setCobuyerData((prev) => ({
        ...prev,
        city: suggestion,
      }));
    } else {
      setPrimaryBuyerData((prev) => ({
        ...prev,
        city: suggestion,
      }));
    }
    setCitySuggestions([]);
    setShowSuggestions(false);
  };

  const phoneNumberVerification = async (name, value) => {
    try {
      const [phoneInUse, phoneVerified] = await Promise.all([
        isPhoneNoInUse(value),
        isPhoneNoVerified(value),
      ]);

      if (phoneInUse?.data?.data) {
        // Phone number already in use by another user
        setIsNumberVerified(false);
        setSendVerificationCode({
          message:
            "This phone number is already verified for another user. Please use a different number.",
          showCta: false,
        });
      } else if (phoneVerified?.data?.data) {
        // Phone number is verified
        setIsNumberVerified(true);
        setSendVerificationCode({
          message: null,
          showCta: false,
        });
      } else {
        // Phone number needs verification
        setIsNumberVerified(false);
        setSendVerificationCode({
          message: "We will text you one time verification code",
          showCta: true,
        });
      }

      setErrors((prev) => ({
        ...prev,
        primaryBuyer: {
          ...prev.primaryBuyer,
          [name]: null,
        },
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const validateAddressFields = async (addressData) => {
    try {
      setIsValidating(true); // Start showing shimmer

      const [isphoneinuse, isphoneverified] = await Promise.all([
        isPhoneNoInUse(addressData?.phone),
        isPhoneNoVerified(addressData?.phone),
      ]);

      if (
        isphoneverified?.data?.status === "SUCCESS" &&
        isphoneinuse?.data?.status === "SUCCESS"
      ) {
        const payload = {
          address1: addressData.address1,
          city: addressData.city,
          state: addressData.stateId,
          zip: addressData.zip,
        };
        const data = await validateAddress(payload);
        if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
          return "Invalid combination of State and ZIP code";
        }
        return null;
      } else {
        alert("phone no is not verified");
        return "Phone number is not verified";
      }
    } catch (error) {
      console.log(error);
      return "Error validating address";
    } finally {
      setIsValidating(false); // Stop showing shimmer
    }
  };

  // const validateField = (value, type, fieldName) => {
  //   // Get custom error message for empty fields
  //   const getEmptyFieldError = (fieldName) => {
  //     switch (fieldName) {
  //       // Basic fields
  //       case "firstName":
  //       case "lastName":
  //         return "Invalid Name";
  //       case "companyName":
  //         return "Invalid corporation name";
  //       case "address1":
  //         return "Invalid individual address";
  //       case "city":
  //         return "Invalid City";
  //       case "stateId":
  //         return "Please select a state";
  //       case "phone":
  //         return "Invalid Phone Number";
  //       case "zip":
  //         return "Invalid Zip Code";
  //       case "email":
  //         return "Invalid email format";

  //       // CWCOT and CWCOT-CA specific fields
  //       case "organizationName":
  //         return "Please enter valid Non profit Entity";
  //       case "governmentEntityName":
  //         return "Please enter valid governmental entity";
  //       case "nonProfitCorpName":
  //         return "Please enter valid non-profit corporation";
  //       case "landTrustName":
  //         return "Please enter valid community land trust";
  //       case "housingCoopName":
  //         return "Please enter valid Housing cooperative ";
  //       case "ownerOccupiedName":
  //         return "Please enter valid Owner occupied";
  //       case "californiaStateName":
  //         return "Please enter valid California state";
  //       // Add CA Bill specific fields
  //       case "caBillOwnerOccupiedName":
  //         return "CA Bill Owner occupied name is required";
  //       case "caBillNonProfitName":
  //         return "Please enter valid non-profit corporation";
  //       case "caBillLandTrustName":
  //         return "Please enter valid community land trust";
  //       case "caBillHousingCoopName":
  //         return "Please enter valid Housing cooperative ";
  //       case "caBillCaliforniaStateName":
  //         return "Please enter valid California state";
  //       default:
  //         return "This field is required";
  //     }
  //   };

  //   if (!value) return getEmptyFieldError(fieldName);

  //   switch (type) {
  //     case "email":
  //       return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  //         ? null
  //         : "Invalid email format";
  //     case "phone":
  //       return /^\d{10}$/.test(value.replace(/\D/g, ""))
  //         ? null
  //         : "Invalid Phone Number";
  //     case "zip":
  //       return /^\d{5}(-\d{4})?$/.test(value) ? null : "Invalid Zip Code";
  //     default:
  //       return null;
  //   }
  // };
  const validateField = (value, type, fieldName) => {
    const getEmptyFieldError = (fieldName) => {
      switch (fieldName) {
        case "firstName":
        case "lastName":
          return "Invalid Name";
        // case "middleInitials":
        //   return "Invalid middlename";
        case "companyName":
          return "Invalid corporation name";
        case "address1":
          return "Invalid individual address";
        case "city":
          return "Invalid City";
        case "stateId":
          return "Please select a state";
        case "phone":
          return "Invalid Phone Number";
        case "zip":
          return "Invalid Zip Code";
        case "email":
          return "Invalid Email";
        case "organizationName":
          return "Please enter valid Non profit Entity";
        case "governmentEntityName":
          return "Please enter valid governmental entity";
        case "nonProfitCorpName":
          return "Please enter valid non-profit corporation";
        case "landTrustName":
          return "Please enter valid community land trust";
        case "housingCoopName":
          return "Please enter valid limited equity housing co-operative";
        case "ownerOccupiedName":
          return "Please enter valid Owner occupied";
        case "californiaStateName":
          return "Please enter valid California state";
        case "caBillOwnerOccupiedName":
          return "CA Bill Owner occupied name is required";
        case "caBillNonProfitName":
          return "Please enter valid non-profit corporation";
        case "caBillLandTrustName":
          return "Please enter valid community land trust";
        case "caBillHousingCoopName":
          return "Please enter valid limited equity housing co-operative";
        case "caBillCaliforniaStateName":
          return "Please enter valid California state";
        default:
          return "";
      }
    };

    if (!value?.trim()) return getEmptyFieldError(fieldName);

    switch (fieldName) {
      case "firstName":
      case "lastName":
        if (!value.trim()) return "This field is required";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Characters allowed: a-z A-Z 0-9 and - . ' _";
      case "middleInitials":
        if (!value.trim()) return "This field is required";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Characters allowed: a-z A-Z 0-9 and - . ' _";
      case "caBillLandTrustName":
        if (!value.trim()) return "Please enter valid community land trust";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Please enter valid community land trust";

      case "caBillNonProfitName":
        if (!value.trim()) return "Please enter valid non-profit corporation";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Please enter valid non-profit corporation";

      case "caBillHousingCoopName":
        if (!value.trim())
          return "Please enter valid limited equity housing co-operative";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Please enter valid limited equity housing co-operative";

      case "companyName":
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Invalid corporation name";

      // case "address1":
      //   return value.length < 1
      //     ? "Address should be at least 5 characters long"
      //     : null;
      case "city":
        if (!value.trim()) return "This field is required";
        return /^[a-zA-Z0-9\-._' ]*$/.test(value)
          ? null
          : "Characters allowed: a-z A-Z 0-9 and - . ' _";

      case "address1":
        return /^[a-zA-Z0-9#(),.'\s]*$/.test(value)
          ? null
          : "Characters allowed: a-z A-Z 0-9, space, and # (max 30 characters)";

      case "zip":
        return /^\d{5}(-\d{4})?$/.test(value) ? null : "Invalid Zip Code";
      case "phone":
        return /^\d{10}$/.test(value.replace(/\D/g, ""))
          ? null
          : "Invalid Phone Number";
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? null
          : "Invalid Email";
      default:
        return null;
    }
  };

  const validateBuyerData = (buyerData, entityType, isCobuyer = false) => {
    const errors = {};

    // Base required fields for all types
    const requiredFields = [
      { name: "firstName", type: "text" },
      { name: "lastName", type: "text" },
      { name: "email", type: "email" },
      { name: "phone", type: "phone" },
      { name: "address1", type: "text" },
      { name: "city", type: "text" },
      { name: "stateId", type: "text" },
      { name: "zip", type: "zip" },
    ];

    // Add entity-specific required fields
    if (entityType === "business") {
      requiredFields.push({ name: "companyName", type: "text" });
    }

    // Add CWCOT and CWCOT-CA specific fields
    if (isCWCOTProp || isCWCOTCAProp) {
      switch (entityType) {
        case "hudNonProfit":
        case "cwcotHudNonProfit":
          requiredFields.push({ name: "organizationName", type: "text" });
          break;
        case "government":
        case "cwcotGovernment":
          requiredFields.push({ name: "governmentEntityName", type: "text" });
          break;
        case "nonProfitCorp":
          requiredFields.push({ name: "nonProfitCorpName", type: "text" });
          break;
        case "landTrust":
          requiredFields.push({ name: "landTrustName", type: "text" });
          break;
        case "housingCoop":
          requiredFields.push({ name: "housingCoopName", type: "text" });
          break;
        // case "ownerOccupied":
        //   requiredFields.push({ name: "ownerOccupiedName", type: "text" });
        //   break;
        // case "california":
        //   requiredFields.push({ name: "californiaStateName", type: "text" });
        //   break;
      }
    }
    // Add CA Bill specific fields
    if (isCABillProp) {
      switch (entityType) {
        // case "caBillOwnerOccupied":
        //   requiredFields.push({
        //     name: "caBillOwnerOccupiedName",
        //     type: "text",
        //   });
        //   break;
        case "caBillNonProfit":
          requiredFields.push({ name: "caBillNonProfitName", type: "text" });
          break;
        case "caBillLandTrust":
          requiredFields.push({ name: "caBillLandTrustName", type: "text" });
          break;
        case "caBillHousingCoop":
          requiredFields.push({ name: "caBillHousingCoopName", type: "text" });
          break;
        // case "caBillCaliforniaState":
        //   requiredFields.push({
        //     name: "caBillCaliforniaStateName",
        //     type: "text",
        //   });
        //   break;
      }
    }
    // Validate each field
    requiredFields.forEach((field) => {
      const error = validateField(
        buyerData[field.name],
        field.type,
        field.name
      );
      if (error) errors[field.name] = error;
    });
    // Add phone verification check
    if (buyerData.phone?.length === 10 && !isNumberVerified) {
      console.log("Phone verification failed");
      errors.phone = "Please verify the phone number";
    }
    return Object.keys(errors).length > 0 ? errors : null;
  };
  const handleEntityTypeChange = (value, isCobuyer = false) => {
    // First determine if we're dealing with CWCOT properties
    const isCWCOTProperty = isCWCOTProp || isCWCOTCAProp;

    if (isCobuyer && !isCWCOTProperty) {
      // Handle co-buyer for non-CWCOT properties
      setCobuyerEntityType(value);

      // Clear co-buyer form data
      setCobuyerData((prev) => ({
        ...prev,
        companyName: "",
        // Add other fields that need to be cleared
      }));

      // Always clear co-buyer documents when switching entity type
      if (coBuyerFileInputRef.current) {
        coBuyerFileInputRef.current.value = "";
      }

      setUploadedFiles((prev) => ({
        ...prev,
        coBuyer: [], // Changed from null to empty array
      }));

      // // Set appropriate error message for business entity
      // setErrors((prev) => ({
      //   ...prev,
      //   coBuyer: {
      //     ...(prev.coBuyer || {}),
      //     documents:
      //       value === "business"
      //         ? "Please upload at least one llc document to proceed."
      //         : undefined,
      //   },
      // }));
      // Only set document error if there was a previous submission attempt
      setErrors((prev) => ({
        ...prev,
        coBuyer: {
          ...(prev.coBuyer || {}),
          documents: undefined, // Clear document errors on type change
        },
      }));
    } else if (!isCobuyer) {
      // Handle primary buyer
      setPrimaryEntityType(value);

      // Clear primary buyer form data based on entity type
      setPrimaryBuyerData((prev) => ({
        ...prev,
        companyName: "",
        organizationName: "",
        governmentEntityName: "",
        nonProfitCorpName: "",
        landTrustName: "",
        housingCoopName: "",
        // Add other fields that need to be cleared
        // Add CA Bill specific fields
        caBillOwnerOccupiedName: "",
        caBillNonProfitName: "",
        caBillLandTrustName: "",
        caBillHousingCoopName: "",
        caBillCaliforniaStateName: "",
      }));

      // Clear file input
      if (primaryFileInputRef.current) {
        primaryFileInputRef.current.value = "";
      }

      // Clear uploaded files
      setUploadedFiles((prev) => ({
        ...prev,
        primaryBuyer: [],
      }));

      // Set appropriate error messages based on entity type
      if (isCWCOTProperty) {
        // For CWCOT properties
        // setErrors((prev) => ({
        //   ...prev,
        //   primaryBuyer: {
        //     ...(prev.primaryBuyer || {}),
        //     documents: shouldShowDocumentUpload(
        //       value,
        //       isCWCOTProp,
        //       isCWCOTCAProp
        //     )
        //       ? "Please upload at least one eligibility declaration form document to proceed."
        //       : undefined,
        //   },
        // }));
        setErrors((prev) => ({
          ...prev,
          primaryBuyer: {
            ...(prev.primaryBuyer || {}),
            documents: undefined, // Clear document errors
          },
        }));
      } else if (isCABillProp) {
        // For CA Bill properties
        setErrors((prev) => ({
          ...prev,
          primaryBuyer: {
            ...(prev.primaryBuyer || {}),
            documents: undefined, // Clear document errors
            // Clear any CA Bill specific field errors
            caBillOwnerOccupiedName: undefined,
            caBillNonProfitName: undefined,
            caBillLandTrustName: undefined,
            caBillHousingCoopName: undefined,
            caBillCaliforniaStateName: undefined,
          },
        }));
      } else {
        // For non-CWCOT properties
        // setErrors((prev) => ({
        //   ...prev,
        //   primaryBuyer: {
        //     ...(prev.primaryBuyer || {}),
        //     documents:
        //       value === "business"
        //         ? "Please upload at least one llc document to proceed."
        //         : undefined,
        //   },
        // }));
        setErrors((prev) => ({
          ...prev,
          primaryBuyer: {
            ...(prev.primaryBuyer || {}),
            documents: undefined, // Clear document errors
          },
        }));
      }
    }
  };
  useEffect(() => {
    console.log("Form State Updated:", {
      entityType: primaryEntityType,
      formData: primaryBuyerData,
      uploadedFiles,
      errors,
      isCWCOTCAProp,
    });
  }, [primaryEntityType, primaryBuyerData, uploadedFiles, errors]);

  // Add this to your useEffect or where you initialize the component
  // useEffect(() => {
  //   // Only set default entity type if not in edit mode

  //   if (propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL") {
  //     setPrimaryEntityType("business");
  //   }
  //   else {
  //     if (isCWCOTCAProp) {
  //       setPrimaryEntityType("ownerOccupied");
  //     } else if (isCWCOTProp) {
  //       setPrimaryEntityType("selfOccupancy");
  //     } else if (isCABillProp) {
  //       setPrimaryEntityType("caBillOwnerOccupied"); // Set default CA Bill entity type
  //     } else{
  //       setPrimaryEntityType("individual");
  //     }

  //   }

  // }, [isCWCOTCAProp, isCWCOTProp]);

  const getEntityFields = () => {
    console.log("isCWCOTProp -> ", primaryEntityType);
    if (isCWCOTProp) {
      switch (primaryEntityType) {
        case "selfOccupancy":
          return selfOccupancyFields;
        case "hudNonProfit":
          return hudNonProfitFields;
        case "government":
          return governmentEntityFields;
        default:
          return buyerFields;
      }
    }

    if (isCWCOTCAProp) {
      switch (primaryEntityType) {
        case "ownerOccupied":
          return ownerOccupiedFields;
        case "nonProfitCorp":
          return nonProfitCorpFields;
        case "landTrust":
          return landTrustFields;
        case "housingCoop":
          return housingCoopFields;
        case "california":
          return californiaStateFields;
        case "cwcotHudNonProfit":
          return cwcotHudNonProfitFields;
        case "cwcotGovernment":
          return cwcotGovernmentFields;
        default:
          return buyerFields;
      }
    }
    if (isCABillProp) {
      switch (primaryEntityType) {
        case "caBillOwnerOccupied":
          return caBillOwnerOccupiedFields;
        case "caBillNonProfit":
          return caBillNonProfitFields;
        case "caBillLandTrust":
          return caBillLandTrustFields;
        case "caBillHousingCoop":
          return caBillHousingCoopFields;
        case "caBillCaliforniaState":
          return caBillCaliforniaStateFields;
        default:
          return buyerFields;
      }
    }
    if (isFirstLookProp) {
      switch (primaryEntityType) {
        case "firstLookOwnerOccupied":
          return firstLookOwnerOccupiedFields;
        case "firstLookNonProfit":
          return firstLookNonProfitFields;
        default:
          return buyerFields;
      }
    }
    // Default non-CWCOT options
    return primaryEntityType === "individual" ? buyerFields : businessFields;
  };

  const shouldShowDocumentUpload = (
    entityType,
    isCWCOTProp,
    isCWCOTCAProp,
    isCABillProp
  ) => {
    // For non-CWCOT properties
    if (!isCWCOTProp && !isCWCOTCAProp && !isCABillProp) {
      return entityType === "business" && formState?.llc === "Required";
    }

    // For non-CA CWCOT properties
    if (isCWCOTProp) {
      switch (entityType) {
        case "selfOccupancy":
          return true;
        case "hudNonProfit":
          return false; // Only input field, no document
        case "government":
          return true;
        default:
          return false;
      }
    }

    // For CA CWCOT properties
    if (isCWCOTCAProp) {
      switch (entityType) {
        case "ownerOccupied":
          return true;
        case "nonProfitCorp":
          return true;
        case "landTrust":
          return true;
        case "housingCoop":
          return true;
        case "california":
          return true;
        case "cwcotHudNonProfit":
          return false; // Only input field, no document
        case "cwcotGovernment":
          return true;
        default:
          return false;
      }
    }
    // For CA Bill properties
    if (isCABillProp) {
      switch (entityType) {
        case "caBillOwnerOccupied":
          return true;
        case "caBillNonProfit":
          return true;
        case "caBillLandTrust":
          return true;
        case "caBillHousingCoop":
          return true;
        case "caBillCaliforniaState":
          return true;
        default:
          return false;
      }
    }
    return false;
  };

  const getDocumentUploadMessage = (
    entityType,
    isCWCOTProp,
    isCWCOTCAProp,
    isCABillProp,
    handleEligibilityFormDownload // Add this parameter
  ) => {
    if (isCWCOTProp) {
      switch (entityType) {
        case "selfOccupancy":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Owner-Occupied Buyer Attestation Form{" "}
              </a>
            </span>
          );
        case "hudNonProfit":
          return "Please upload HUD approval documentation";
        case "government":
          return "Please provide a signed statement on your letterhead stating that you are a Governmental Entity";
        default:
          return "Please upload required documents";
      }
    }

    if (isCWCOTCAProp) {
      switch (entityType) {
        case "ownerOccupied":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "nonProfitCorp":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "landTrust":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "housingCoop":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "california":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "cwcotHudNonProfit":
          return "Please upload HUD approval documentation";
        case "cwcotGovernment":
          return "Please provide a signed statement on your letterhead stating that you are a Governmental Entity";
        default:
          return "Please upload required documents";
      }
    }
    if (isCABillProp) {
      switch (entityType) {
        case "caBillOwnerOccupied":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "caBillNonProfit":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "caBillLandTrust":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "caBillHousingCoop":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        case "caBillCaliforniaState":
          return (
            <span className="cifTxt">
              Please upload a signed copy of our{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEligibilityFormDownload();
                }}
                className="eligibility-document"
              >
                Eligibility Declaration Form
              </a>
            </span>
          );
        default:
          return "Please upload required documents";
      }
    }
    // For business entity
    if (entityType === "business") {
      return "Please upload Business Entity formation documents here (E.g.: LLC - Certificate of Formation, Corporation - Articles of Incorporation, LP - Certificate of Limited Partnership, etc.)";
    }

    return "Please upload required documents";
  };

  const getDocumentTooltip = (
    entityType,
    isCWCOTProp,
    isCWCOTCAProp,
    isCABillProp
  ) => {
    // todo:may be in future if they want tooltip just uncomment the below line....
    // if (isCWCOTProp) {
    //   switch (entityType) {
    //     case "selfOccupancy":
    //       return "Upload signed Self Occupancy Certification form";
    //     case "hudNonProfit":
    //       return "Upload current HUD approval letter and supporting documentation";
    //     case "government":
    //       return "Upload government entity verification documents";
    //     default:
    //       return "Upload all required documentation";
    //   }
    // }

    // if (isCWCOTCAProp) {
    //   switch (entityType) {
    //     case "ownerOccupied":
    //       return "Upload signed Owner Occupancy Certification form";
    //     case "nonProfitCorp":
    //       return "Upload Non-Profit status verification and incorporation documents";
    //     case "landTrust":
    //       return "Upload Land Trust certification and registration documents";
    //     case "housingCoop":
    //       return "Upload Housing Co-operative registration and verification documents";
    //     case "california":
    //       return "Upload State of California required documentation";
    //     case "cwcotHudNonProfit":
    //       return "Upload current HUD approval letter and supporting documentation";
    //     case "cwcotGovernment":
    //       return "Upload government entity verification documents";
    //     default:
    //       return "Upload all required documentation";
    //   }
    // }
    // if (isCABillProp) {
    //   switch (entityType) {
    //     case "caBillOwnerOccupied":
    //       return "Upload signed Individual Certification form";
    //     case "caBillNonProfit":
    //       return "Upload Non-Profit status verification and documentation";
    //     case "caBillLandTrust":
    //       return "Upload Community Land Trust certification and registration documents";
    //     case "caBillHousingCoop":
    //       return "Upload Limited Partnership registration and verification documents";
    //     case "caBillCaliforniaState":
    //       return "Upload Cooperative Housing registration and verification documents";
    //     default:
    //       return "Upload all required documentation";
    //   }
    // }
    // For business entity
    if (entityType === "business") {
      return "If a legal entity is purchasing the property, please upload the formation documents for that entity stamped as filed with the relevant state agency (typically the office of the Secretary of State where the entity was formed). Examples of acceptable documents include stamped copies of: the Articles of Incorporation of a corporation, Certificate of Formation for a LLC, Certificate of Limited Partnership for a LP.";
    }

    return "";
  };
  const getDocumentUploadLabel = (
    entityType,
    isCWCOTProp,
    isCWCOTCAProp,
    isCABillProp
  ) => {
    if (isCWCOTProp) {
      switch (entityType) {
        case "selfOccupancy":
          return "Upload Owner-Occupied Buyer Attestation Form";
        case "hudNonProfit":
          return "Upload HUD Approval Documentation";
        case "government":
          return "Upload Signed Statement";
        default:
          return "Upload Required Documents";
      }
    }

    if (isCWCOTCAProp) {
      switch (entityType) {
        case "ownerOccupied":
          return "Upload Eligibility Declaration Form*";
        case "nonProfitCorp":
          return "Upload Eligibility Declaration Form*";
        case "landTrust":
          return "Upload Eligibility Declaration Form*";
        case "housingCoop":
          return "Upload Eligibility Declaration Form*";
        case "california":
          return "Upload Eligibility Declaration Form*";
        case "cwcotHudNonProfit":
          return "Upload HUD Approval Documentation";
        case "cwcotGovernment":
          return "Upload Signed Statement*";
        default:
          return "Upload Required Documents";
      }
    }
    if (isCABillProp) {
      switch (entityType) {
        case "caBillOwnerOccupied":
          return "Upload Eligibility Declaration Form*";
        case "caBillNonProfit":
          return "Upload Eligibility Declaration Form*";
        case "caBillLandTrust":
          return "Upload Eligibility Declaration Form*";
        case "caBillHousingCoop":
          return "Upload Eligibility Declaration Form*";
        case "caBillCaliforniaState":
          return "Upload Eligibility Declaration Form*";
        default:
          return "Upload all required documentation";
      }
    }
    // For business entity
    if (entityType === "business") {
      return "Upload Business Entity Formation Documents";
    }

    return "Upload Required Documents";
  };
  // Add this new function alongside your other handlers
  const handleFileDownload = (file) => {
    try {
      const a = document.createElement("a");
      a.href = file.downloadUrl;
      a.download = file.fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const selectedDoc = uploadedFiles[getDocumnetsForbuyerCategory()];
  // Add the download handler function in your component:
  const handleEligibilityFormDownload = async () => {
    try {
      const response = await fetch(
        "https://image-prod.hubzu.com/California/Eligibility_Declaration_Form.pdf"
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Eligibility_Declaration_Form.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading eligibility form:", error);
      // Handle error appropriately
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    try {
      let hasErrors = false;
      const newErrors = {};

      // Validate primary buyer data
      const primaryBuyerErrors = validateBuyerData(
        primaryBuyerData,
        primaryEntityType,
        false
      );
      if (primaryBuyerErrors) {
        newErrors.primaryBuyer = primaryBuyerErrors;
        hasErrors = true;
      }

      const sameBuyerEmail =
        primaryBuyerData?.email?.toUpperCase() ===
        agentData?.email?.toUpperCase();
      const sameCoBuyerEmail =
        cobuyerData?.email?.toUpperCase() === agentData?.email?.toUpperCase();
      const sameCoBuyerBuyer =
        cobuyerData?.email?.toUpperCase() ===
        primaryBuyerData?.email.toUpperCase();

      if (primaryBuyerData?.email?.length > 0 && sameBuyerEmail) {
        hasErrors = true;

        if (!newErrors.primaryBuyer) newErrors.primaryBuyer = {};
        newErrors.primaryBuyer.email =
          "Buyer and Agent email should not be same";
      }
      if (cobuyerData?.email?.length > 0) {
        if (sameCoBuyerEmail) {
          hasErrors = true;
          if (!newErrors.coBuyer) newErrors.coBuyer = {};
          newErrors.coBuyer.email =
            "Co-Buyer and Agent email should not be same";
        }
      }

      if (hasCobuyer === "yes") {
        if (cobuyerData?.email?.length > 0 && sameCoBuyerBuyer) {
          hasErrors = true;
          if (!newErrors.coBuyer) newErrors.coBuyer = {};
          newErrors.coBuyer.email =
            "Buyer and Co-Buyer email should not be same";
        }
      }

      // Validate primary buyer address
      const primaryAddressError = await validateAddressFields(primaryBuyerData);
      // if (primaryAddressError) {
      //   newErrors.primaryAddress = primaryAddressError;
      //   hasErrors = true;
      // }
      // Todo: if you want to show th error msg below the input field with the border red color and error msg below then write this bwlow code without changing any exisitng logic
      if (primaryAddressError) {
        hasErrors = true;
        if (!newErrors.primaryBuyer) newErrors.primaryBuyer = {};

        if (primaryAddressError.includes("State and ZIP")) {
          newErrors.primaryBuyer.stateId = "Please select a state";
          newErrors.primaryBuyer.zip = "Invalid Zip Code for selected state";
        } else {
          newErrors.primaryBuyer.address1 = "Invalid Address";
          newErrors.primaryBuyer.city = "Invalid City";
          newErrors.primaryBuyer.stateId = "Please select a state";
          newErrors.primaryBuyer.zip = "Invalid Zip Code";
        }
      }

      // Validate primary buyer documents based on entity type
      if (isCWCOTProp || isCWCOTCAProp) {
        if (
          !["hudNonProfit", "cwcotHudNonProfit"].includes(primaryEntityType) &&
          (!uploadedFiles[getDocumnetsForbuyerCategory()] ||
            uploadedFiles[getDocumnetsForbuyerCategory()].length === 0) // Changed this line
        ) {
          if (!newErrors.primaryBuyer) newErrors.primaryBuyer = {};
          newErrors.primaryBuyer.documents =
            "Please upload at least one eligibility declaration form document to proceed.";
          hasErrors = true;
        }
      } else if (isCABillProp) {
        // CA Bill document validation
        if (
          !uploadedFiles[getDocumnetsForbuyerCategory()] ||
          uploadedFiles[getDocumnetsForbuyerCategory()].length === 0
        ) {
          if (!newErrors.primaryBuyer) newErrors.primaryBuyer = {};
          // newErrors.primaryBuyer.documents = `Please upload required documents for ${primaryEntityType.replace(
          //   "caBill",
          //   "CA Bill "
          // )} to proceed.`;

          newErrors.primaryBuyer.documents =
            "Please upload at least one eligibility declaration form document to proceed.";
          hasErrors = true;
        }
      } else if (
        primaryEntityType === FILE_TYPES.BUSINESS &&
        formState?.llc === "Required" &&
        (!uploadedFiles[getDocumnetsForbuyerCategory()] ||
          uploadedFiles[getDocumnetsForbuyerCategory()].length === 0) // Changed this line
      ) {
        if (!newErrors.primaryBuyer) newErrors.primaryBuyer = {};
        newErrors.primaryBuyer.documents =
          "Please upload at least one llc document to proceed.";
        hasErrors = true;
      }

      // Validate co-buyer if present
      if (hasCobuyer === "yes") {
        const coBuyerErrors = validateBuyerData(
          cobuyerData,
          cobuyerEntityType,
          true
        );
        if (coBuyerErrors) {
          newErrors.coBuyer = coBuyerErrors;
          hasErrors = true;
        }

        const coAddressError = await validateAddressFields(cobuyerData);
        // if (coAddressError) {
        //   newErrors.coAddress = coAddressError;
        //   hasErrors = true;
        // }
        // Todo: if you want to show th error msg below the input field with the border red color and error msg below then write this bwlow code without changing any exisitng logic
        if (coAddressError) {
          hasErrors = true;
          if (!newErrors.coBuyer) newErrors.coBuyer = {};

          if (coAddressError.includes("State and ZIP")) {
            newErrors.coBuyer.stateId = "Please select a state";
            newErrors.coBuyer.zip = "Invalid Zip Code for selected state";
          } else {
            newErrors.coBuyer.address1 = "Invalid Address";
            newErrors.coBuyer.city = "Invalid City";
            newErrors.coBuyer.stateId = "Please select a state";
            newErrors.coBuyer.zip = "Invalid Zip Code";
          }
        }
        // Only validate co-buyer documents for non-CWCOT business entities
        if (
          !isCWCOTProp &&
          !isCWCOTCAProp &&
          cobuyerEntityType === FILE_TYPES.BUSINESS &&
          formState?.llc === "Required" &&
          (!uploadedFiles.coBuyer || uploadedFiles.coBuyer.length === 0) // Changed this line
        ) {
          if (!newErrors.coBuyer) newErrors.coBuyer = {};
          newErrors.coBuyer.documents =
            "Please upload at least one llc document to proceed.";
          hasErrors = true;
        }
      }

      setErrors(newErrors);

      if (newErrors.coBuyer && Object.keys(newErrors.coBuyer)?.length > 0) {
        const errorField = Object.keys(newErrors.coBuyer)[0];
        console.log("errorField ->", errorField);

        cobuyerFormRef.current[errorField]?.focus();
        cobuyerFormRef.current[errorField]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      if (
        newErrors.primaryBuyer &&
        Object.keys(newErrors.primaryBuyer)?.length > 0
      ) {
        const errorField = Object.keys(newErrors.primaryBuyer)[0];
        console.log("errorField ->", errorField);

        buyerFormRef.current[errorField]?.focus();
        buyerFormRef.current[errorField]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      if (!hasErrors) {
        // Create submission data object
        const submissionData = {
          primaryBuyer: {
            entityType: primaryEntityType,
            firstName: primaryBuyerData?.firstName,
            lastName: primaryBuyerData?.lastName,
            middleInitials: primaryBuyerData?.middleInitials,
            email: primaryBuyerData?.email,
            phone: primaryBuyerData?.phone,
            address1: primaryBuyerData?.address1,
            address2: primaryBuyerData?.address2,
            city: primaryBuyerData?.city,
            stateId: primaryBuyerData?.stateId,
            zip: primaryBuyerData?.zip,
            documents: uploadedFiles[getDocumnetsForbuyerCategory()],

            // Add entity-specific fields based on type
            ...(primaryEntityType === FILE_TYPES.BUSINESS && {
              companyName: primaryBuyerData.companyName,
            }),
            ...(primaryEntityType === "hudNonProfit" && {
              organizationName: primaryBuyerData.organizationName,
            }),
            ...(primaryEntityType === "government" && {
              governmentEntityName: primaryBuyerData.governmentEntityName,
            }),
            ...(primaryEntityType === "nonProfitCorp" && {
              nonProfitCorpName: primaryBuyerData.nonProfitCorpName,
            }),
            ...(primaryEntityType === "landTrust" && {
              landTrustName: primaryBuyerData.landTrustName,
            }),
            ...(primaryEntityType === "housingCoop" && {
              housingCoopName: primaryBuyerData.housingCoopName,
            }),
            ...(primaryEntityType === "ownerOccupied" && {
              ownerOccupiedName: primaryBuyerData.ownerOccupiedName,
            }),
            ...(primaryEntityType === "california" && {
              californiaStateName: primaryBuyerData.californiaStateName,
            }),
            // Add CA Bill entity-specific fields
            ...(primaryEntityType === "caBillOwnerOccupied" && {
              caBillOwnerOccupiedName: primaryBuyerData.caBillOwnerOccupiedName,
            }),
            ...(primaryEntityType === "caBillNonProfit" && {
              caBillNonProfitName: primaryBuyerData.caBillNonProfitName,
            }),
            ...(primaryEntityType === "caBillLandTrust" && {
              caBillLandTrustName: primaryBuyerData.caBillLandTrustName,
            }),
            ...(primaryEntityType === "caBillHousingCoop" && {
              caBillHousingCoopName: primaryBuyerData.caBillHousingCoopName,
            }),
            ...(primaryEntityType === "caBillCaliforniaState" && {
              caBillCaliforniaStateName:
                primaryBuyerData.caBillCaliforniaStateName,
            }),
          },
        };

        // Add co-buyer data if present
        if (hasCobuyer === "yes") {
          submissionData.coBuyer = {
            // Only include entityType for non-CWCOT properties
            ...(!isCWCOTProp &&
              !isCWCOTCAProp &&
              !isCABillProp && {
                entityType: cobuyerEntityType,
              }),
            firstName: cobuyerData.firstName,
            lastName: cobuyerData.lastName,
            middleInitials: cobuyerData.middleInitials,
            email: cobuyerData.email,
            phone: cobuyerData.phone,
            address1: cobuyerData.address1,
            address2: cobuyerData.address2,
            city: cobuyerData.city,
            stateId: cobuyerData.stateId,
            zip: cobuyerData.zip,
            documents: uploadedFiles.coBuyer,

            // Add entity-specific fields only for non-CWCOT properties
            ...(!isCWCOTProp &&
              !isCWCOTCAProp &&
              !isCABillProp && {
                ...(cobuyerEntityType === FILE_TYPES.BUSINESS && {
                  companyName: cobuyerData.companyName,
                }),
                ...(cobuyerEntityType === "hudNonProfit" && {
                  organizationName: cobuyerData.organizationName,
                }),
                ...(cobuyerEntityType === "government" && {
                  governmentEntityName: cobuyerData.governmentEntityName,
                }),
                ...(cobuyerEntityType === "nonProfitCorp" && {
                  nonProfitCorpName: cobuyerData.nonProfitCorpName,
                }),
                ...(cobuyerEntityType === "landTrust" && {
                  landTrustName: cobuyerData.landTrustName,
                }),
                ...(cobuyerEntityType === "housingCoop" && {
                  housingCoopName: cobuyerData.housingCoopName,
                }),
                ...(cobuyerEntityType === "ownerOccupied" && {
                  ownerOccupiedName: cobuyerData.ownerOccupiedName,
                }),
                ...(cobuyerEntityType === "california" && {
                  californiaStateName: cobuyerData.californiaStateName,
                }),
              }),
          };
        }

        console.log("Submission Data:", submissionData);

        // Handle accordion navigation
        await setSubmittedAccordions((prev) => [...prev, 2]);
        console.log("hhhh", primaryBuyerData);

        if (
          (selectedDescription === "Buyer" && buyingForSelf === "Yes") ||
          (selectedDescription === "Agent" && buyingForSelf === "No")
        ) {
          setCollapseAccordian(3);
          window.scrollTo(0, 900); //Need Fix
        } else {
          await setSubmittedAccordions((prev) => [...prev, 3]);
          setCollapseAccordian(4);
          window.scrollTo(0, 900); //Need Fix
        }
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setErrors((prev) => ({
        ...prev,
        submission: "An error occurred while submitting the form",
      }));
    } finally {
      setIsSubmitting(false);
    }
  };
  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Only digits, max 10
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]})-${match[2]}-${match[3]}`;
    }
    return cleaned;
  };

  // useEffect(() => {
  //   if (hasCobuyer === "yes") {
  //     // Add mode check
  //     if (propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL") {
  //       setCobuyerEntityType("business");
  //     } else {
  //       if (!isCWCOTProp && !isCWCOTCAProp) {
  //         // Only set entity type for non-CWCOT properties
  //         if (propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL") {
  //           setCobuyerEntityType("business");
  //         } else {
  //           setCobuyerEntityType("individual");
  //         }
  //       }
  //     }
  //              console.log('render third');

  //     // Reset co-buyer data regardless of property type
  //     setCobuyerData({});
  //   }
  // }, [hasCobuyer]); // Add mode to dependencies

  const shouldDisableField = (field) => {
    if (
      field.name === "email" &&
      (selectedDescription !== "Agent" || buyingForSelf !== "No")
    ) {
      return true;
    }

    if (
      (field.name === "governmentEntityName" ||
        field.name === "caBillNonProfitName" ||
        field.name === "caBillLandTrustName" ||
        field.name === "caBillHousingCoopName") &&
      !isStateWorkflowDurationActive
    ) {
      return true;
    }
    return false;
  };
  const handleClose = () => setShowVerifyModal(false);
  const handleShow = (e) => {
    e.preventDefault();
    setShowVerifyModal(true);
  };

  const handleVerificationSuccess = () => {
    // Set phone number as verified
    setIsNumberVerified(true);

    // Clear verification message and CTA
    setSendVerificationCode({
      message: null,
      showCta: false,
    });

    // Clear any phone-related errors
    setErrors((prev) => ({
      ...prev,
      primaryBuyer: {
        ...prev.primaryBuyer,
        phone: null,
      },
    }));

    console.log("Phone verification successful!");
  };
  return (
    <div>
      {" "}
      <div className="accordion-item buyer-info-accordion">
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${
              collapseAccordian === 2 ? "" : "collapsed"
            }`}
            type="button"
            onClick={(e) => e.preventDefault()}
            aria-expanded={collapseAccordian === 2}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                {/* Show black icon by default, green only if submitted */}
                {submittedAccordions?.includes(2) && collapseAccordian !== 2 ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                  <span className="bid_font_cif">Buyer's Information</span>
                </div>
              </div>

              {/* Show edit button only if accordion has been submitted */}
              {submittedAccordions?.includes(2) && collapseAccordian !== 2 && (
                <Button
                  variant="link"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCollapseAccordian(2);
                  }}
                  className="text-primary bid_edit mt-2 mt-sm-0"
                >
                  Edit
                </Button>
              )}
            </div>
          </button>
        </h2>
        {/* Summary section when accordion is closed */}
        {collapseAccordian !== 2 && submittedAccordions?.includes(2) && (
          <div className="buyer-info-summary p-3 border-bottom">
            <div className="ms-4">
              <p className="mb-3" style={{ color: "#383b42" }}>
                Buyer's information on legal document will be:
              </p>
              <p
                className="mb-3"
                style={{ fontFamily: "graphikmedium", fontSize: "20px" }}
              >
                Buyer
              </p>
              <p className="mb-0" style={{ color: "#383b42" }}>
                Name:{" "}
                {`${primaryBuyerData?.firstName} ${primaryBuyerData?.lastName}`}
              </p>
              <p className="mb-4" style={{ color: "#383b42" }}>
                Email: {primaryBuyerData?.email}
              </p>

              {/* Co-buyer information if exists */}
              {hasCobuyer === "yes" && cobuyerData && (
                <>
                  <strong className="mb-0">Co-Buyer</strong>
                  <p className="mb-0 mt-2" style={{ color: "#383b42" }}>
                    Name: {`${cobuyerData?.firstName} ${cobuyerData?.lastName}`}
                  </p>
                  <p className="mb-0" style={{ color: "#383b42" }}>
                    {" "}
                    Email: {cobuyerData?.email}
                  </p>
                </>
              )}
            </div>
          </div>
        )}
        <div
          className={`accordion-collapse collapse ${
            collapseAccordian === 2 ? "show" : ""
          }`}
          data-bs-parent="#accordionFlushExample"
        >
          {isEnabled && (
            <div className="accordion-body">
              <Form>
                {/* Primary Buyer Section */}
                <div className="buyer-primary-section mb-4">
                  <div className="second_heading_info">
                    As this profile information will be used to bind legal
                    contract, please ensure to add information correctly.
                    Missing information and/ or inaccurate information can cause
                    the contract to be rejected.
                  </div>
                  <Form.Label column sm="3" style={{ color: "#383B42" }}>
                    Purchase is being made on behalf of:
                  </Form.Label>

                  <Form.Group as={Row} className="mb-3">
                    <Col sm="12">
                      <div className="d-flex flex-column">
                        {/* Show different options based on CWCOT status */}
                        {isCWCOTCAProp ? (
                          // California CWCOT Options

                          <>
                            {/* <h6>Select California CWCOT Entity Type</h6> */}
                            <div className="d-flex flex-wrap gap-3">
                              <Form.Check
                                type="radio"
                                label="Owner Occupied Buyer"
                                id="owner-occupied-type"
                                name="primaryEntityType"
                                value="ownerOccupied"
                                checked={primaryEntityType === "ownerOccupied"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="non-profit-corp-type"
                                label="Non-Profit Corporation"
                                name="primaryEntityType"
                                value="nonProfitCorp"
                                checked={true}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="land-trust-type"
                                label="Community Land Trust"
                                name="primaryEntityType"
                                value="landTrust"
                                checked={primaryEntityType === "landTrust"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="housing-coop-type"
                                label="Limited Equity Housing Co-operative"
                                name="primaryEntityType"
                                value="housingCoop"
                                checked={primaryEntityType === "housingCoop"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="california-type"
                                label="The State of California"
                                name="primaryEntityType"
                                value="california"
                                checked={primaryEntityType === "california"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="hud-nonprofit-type"
                                label="HUD Approved Non-Profit Entity"
                                name="primaryEntityType"
                                value="cwcotHudNonProfit"
                                checked={
                                  primaryEntityType === "cwcotHudNonProfit"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="government-entity-type"
                                label="Governmental Entity"
                                name="primaryEntityType"
                                value="cwcotGovernment"
                                checked={
                                  primaryEntityType === "cwcotGovernment"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              {/* Add other CA CWCOT options */}
                            </div>
                          </>
                        ) : isCWCOTProp ? (
                          // Non-CA CWCOT Options
                          <>
                            {/* <h6>Select CWCOT Entity Type</h6> */}
                            <div className="d-flex flex-wrap gap-3">
                              <Form.Check
                                type="radio"
                                id="self-occupancy-type"
                                label="Buyer for Self Occupancy"
                                name="primaryEntityType"
                                value="selfOccupancy"
                                checked={primaryEntityType === "selfOccupancy"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="hud-non-profit-type"
                                label="HUD Approved Non-Profit Entity"
                                name="primaryEntityType"
                                value="hudNonProfit"
                                checked={primaryEntityType === "hudNonProfit"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="government-type"
                                label="Governmental Entity"
                                name="primaryEntityType"
                                value="government"
                                checked={primaryEntityType === "government"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />

                              {/* Add other CWCOT options */}
                            </div>
                          </>
                        ) : isCABillProp ? ( // Add CA Bill condition
                          // CA Bill Options
                          <>
                            {/* <h6>Select CA Bill Entity Type</h6> */}
                            <div className="d-flex flex-wrap gap-3">
                              <Form.Check
                                type="radio"
                                id="ca-bill-owner-occupied-type"
                                label="Owner Occupied Buyer"
                                name="primaryEntityType"
                                value="caBillOwnerOccupied"
                                checked={
                                  primaryEntityType === "caBillOwnerOccupied"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="ca-bill-non-profit-type"
                                label="Non-Profit Corporation"
                                name="primaryEntityType"
                                value="caBillNonProfit"
                                checked={
                                  primaryEntityType === "caBillNonProfit"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="ca-bill-land-trust-type"
                                label="Community Land Trust"
                                name="primaryEntityType"
                                value="caBillLandTrust"
                                checked={
                                  primaryEntityType === "caBillLandTrust"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="ca-bill-housing-coop-type"
                                label="Limited Equity Housing Co-operative"
                                name="primaryEntityType"
                                value="caBillHousingCoop"
                                checked={
                                  primaryEntityType === "caBillHousingCoop"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                              <Form.Check
                                type="radio"
                                id="ca-bill-california-type"
                                label="The State of California"
                                name="primaryEntityType"
                                value="caBillCaliforniaState"
                                checked={
                                  primaryEntityType === "caBillCaliforniaState"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={!isStateWorkflowDurationActive}
                              />
                            </div>
                          </>
                        ) : isFirstLookProp ? (
                          // First Look (SPS 945) Options.
                          // firstLookReadOnly is true when editing a CIF saved
                          // as First Look after the window expired — the saved
                          // option is shown but the user cannot change it.
                          <>
                            <div className="d-flex flex-wrap gap-3">
                              <Form.Check
                                type="radio"
                                id="first-look-owner-occupied-type"
                                label="Owner Occupied Buyer"
                                name="primaryEntityType"
                                value="firstLookOwnerOccupied"
                                checked={
                                  primaryEntityType === "firstLookOwnerOccupied"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={firstLookReadOnly}
                              />
                              <Form.Check
                                type="radio"
                                id="first-look-non-profit-type"
                                label="Qualified Non-Profit Organization"
                                name="primaryEntityType"
                                value="firstLookNonProfit"
                                checked={
                                  primaryEntityType === "firstLookNonProfit"
                                }
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                                disabled={firstLookReadOnly}
                              />
                            </div>
                          </>
                        ) : (
                          // Regular Non-CWCOT Options
                          <>
                            {/* <h6>Select Entity Type</h6> */}
                            <div className="d-flex flex-wrap gap-3">
                              <Form.Check
                                style={{ color: "#383B42" }}
                                type="radio"
                                id="individual-type" // Add unique ID
                                label="Individual"
                                name="primaryEntityType"
                                value="individual"
                                checked={primaryEntityType === "individual"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                              />
                              <Form.Check
                                style={{ color: "#383B42" }}
                                type="radio"
                                id="business-type" // Add unique ID
                                label="Business Entity"
                                name="primaryEntityType"
                                value="business"
                                checked={primaryEntityType === "business"}
                                onChange={(e) =>
                                  handleEntityTypeChange(e.target.value)
                                }
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </Col>
                  </Form.Group>
                  <Row className="mb-3"> </Row>
                  <Row className="mb-3">
                    {/* Get fields based on entity type using getEntityFields function */}
                    {getEntityFields().map((field, index) => (
                      <Form.Group
                        ref={(el) => (buyerFormRef.current[field.name] = el)}
                        as={Col}
                        md={6}
                        className="mb-3"
                        key={`primary-${index}`}
                      >
                        <Form.Label>
                          {field.label}
                          {field.required && (
                            <span className="" style={{ color: "#d13b3b" }}>
                              *
                            </span>
                          )}
                        </Form.Label>
                        <Col sm="9">
                          {field.type === "select" ? (
                            // Select Field Rendering
                            <>
                              <Form.Select
                                ref={(el) =>
                                  (buyerFormRef.current[field.name] = el)
                                }
                                name={field.name}
                                value={primaryBuyerData[field.name] || ""}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  if (
                                    (name === "zip" &&
                                      /^\d*$/.test(value) &&
                                      value.length <= 5) ||
                                    name !== "zip"
                                  ) {
                                    handlePrimaryBuyerChange(e);
                                  }
                                }}
                                required={field.required}
                                isInvalid={!!errors?.primaryBuyer?.[field.name]}
                                className="py-3"
                              >
                                <option value="">Select {field.label}</option>
                                {states.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </Form.Select>
                              {errors?.primaryBuyer?.[field.name] && (
                                <Form.Control.Feedback type="invalid">
                                  {errors.primaryBuyer[field.name]}
                                </Form.Control.Feedback>
                              )}
                            </>
                          ) : (
                            // Regular Input Field Rendering
                            <div className="phone-field-wrapper">
                              <div className="phone-input-container">
                                <Form.Control
                                  ref={(el) =>
                                    (buyerFormRef.current[field.name] = el)
                                  }
                                  // disabled={shouldDisableEntityName(field)}
                                  type={field.type}
                                  placeholder={field.placeholder}
                                  name={field.name}
                                  pattern={field.pattern}
                                  className="bg-bid-in"
                                  value={
                                    field.name === "phone"
                                      ? formatPhoneNumber(
                                          primaryBuyerData[field?.name] || ""
                                        )
                                      : primaryBuyerData[field?.name] || ""
                                  }
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    if (
                                      (name === "zip" &&
                                        /^\d*$/.test(value) &&
                                        value.length <= 5) ||
                                      name !== "zip"
                                    ) {
                                      handlePrimaryBuyerChange(e);
                                    }
                                  }}
                                  // onChange={handlePrimaryBuyerChange}
                                  onBlur={(e) => handleValidationOnBlur(e)}
                                  required={field.required}
                                  isInvalid={
                                    !!errors?.primaryBuyer?.[field.name]
                                  }
                                  maxLength={field.maxLength}
                                  disabled={
                                    shouldDisableField(field)
                                    // field.name === "email" &&
                                    // (selectedDescription !== "Agent" ||
                                    //   buyingForSelf !== "No")

                                    //   (field.name === 'governmentEntityName'
                                    //     || field.name === 'caBillNonProfitName'
                                    //     || field.name === 'caBillLandTrustName'
                                    //     || field.name === 'caBillHousingCoopName') &&
                                    //     shouldDisableField(field)
                                  }
                                  readOnly={shouldDisableField(field)}
                                  style={
                                    field.name === "email" &&
                                    (selectedDescription !== "Agent" ||
                                      buyingForSelf !== "No")
                                      ? {
                                          backgroundColor: "#e9ecef",
                                          cursor: "not-allowed",
                                        }
                                      : {}
                                  }
                                />
                                {field.name === "city" &&
                                  showSuggestions &&
                                  citySuggestions.length > 0 && (
                                    <div className="suggestions-container-bid">
                                      {citySuggestions.map(
                                        (suggestion, index) => (
                                          <div
                                            key={index}
                                            className="suggestion-item"
                                            onClick={() =>
                                              handleSuggestionClick(suggestion)
                                            }
                                          >
                                            {suggestion}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                {/* {errors?.primaryBuyer?.[field.name] && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.primaryBuyer[field.name]}
                                  </Form.Control.Feedback>
                                )} */}
                                {/* {errors?.primaryBuyer?.[field.name] && (
                                  <Form.Control.Feedback type="invalid">
                                    {field.name === "address1" &&
                                    primaryEntityType === "business"
                                      ? "Invalid corporation address"
                                      : errors.primaryBuyer[field.name]}
                                  </Form.Control.Feedback>
                                )} */}
                                {errors?.primaryBuyer?.[field.name] && (
                                  <Form.Control.Feedback type="invalid">
                                    {field.name === "address1" &&
                                    primaryEntityType === "business"
                                      ? "Invalid corporation address"
                                      : field.name === "phone" &&
                                        primaryBuyerData[field.name]?.length ===
                                          10 &&
                                        !isNumberVerified
                                      ? "Please verify the phone number"
                                      : errors.primaryBuyer[field.name]}
                                  </Form.Control.Feedback>
                                )}

                                {field.name === "phone" &&
                                  !(
                                    selectedDescription === "Agent" &&
                                    buyingForSelf === "No"
                                  ) && (
                                    <div className="phone-status-icons">
                                      {primaryBuyerData[field.name]?.length ===
                                        10 && (
                                        <>
                                          {isNumberVerified ? (
                                            // Show blue tick for verified number
                                            <img
                                              src={VerificationTick}
                                              alt="verified"
                                              className="phone-verification-icon"
                                            />
                                          ) : (
                                            // Show warning icon and verify button for unverified 10-digit number
                                            sentVerificationCode.message
                                              ?.length > 0 && (
                                              <img
                                                src={VerificationPending}
                                                alt="verification pending"
                                                className="phone-verification-icon"
                                              />
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                  )}

                                {/* Verification message below input */}
                                {field.name === "phone" &&
                                  primaryBuyerData[field.name]?.length === 10 &&
                                  !isNumberVerified &&
                                  sentVerificationCode.message && (
                                    <div className="errorTxt">
                                      {sentVerificationCode.message}
                                    </div>
                                  )}
                              </div>
                              {/* Verify button moved outside phone-input-container */}
                              {field.name === "phone" &&
                                primaryBuyerData[field.name]?.length === 10 &&
                                !isNumberVerified &&
                                sentVerificationCode.showCta && (
                                  <button
                                    onClick={handleShow}
                                    className="phone-verify-button"
                                  >
                                    Verify
                                  </button>
                                )}

                              {/* City Suggestions */}
                            </div>
                          )}
                        </Col>
                      </Form.Group>
                    ))}
                  </Row>

                  {/* Then render document upload section if needed */}
                  {shouldShowDocumentUpload(
                    primaryEntityType,
                    isCWCOTProp,
                    isCWCOTCAProp,
                    isCABillProp
                  ) && (
                    <Row>
                      <p className="mt-4 cifTxt">
                        {getDocumentUploadMessage(
                          primaryEntityType,
                          isCWCOTProp,
                          isCWCOTCAProp,
                          isCABillProp,
                          handleEligibilityFormDownload
                        )}
                      </p>
                      {(isCWCOTCAProp || isCABillProp) && (
                        <div className="d-flex align-items-center gap-2">
                          <BuyerAccordian_icon className="" />
                          <p className="mb-0 cifTxt1">
                            Please ensure that your selection in the attachment
                            is same as the option you have chosen above
                          </p>
                        </div>
                      )}

                      <Form.Group
                        as={Col}
                        className="mb-3 d-flex align-items-center justify-content-center flex-column p-5"
                        style={{
                          border: "2px dotted #C5E3FF",
                          marginTop: "1rem",
                        }}
                      >
                        <Form.Label className="text-center my-4 d-flex align-items-center justify-content-around">
                          <span
                            style={{
                              color: "#383B42",
                              fontSize: "26px",
                              fontWeight: "500",
                              letterSpacing: "0",
                              lineHeight: "29px",
                              textAlign: "center",
                              fontFamily: "graphikmedium",
                            }}
                          >
                            {getDocumentUploadLabel(
                              primaryEntityType,
                              isCWCOTProp,
                              isCWCOTCAProp,
                              isCABillProp
                            )
                              .split("*")
                              .map((part, index, array) => (
                                <React.Fragment key={index}>
                                  {part}
                                  {index < array.length - 1 && (
                                    <span
                                      className="text-danger"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      *
                                    </span>
                                  )}
                                </React.Fragment>
                              ))}
                          </span>
                          {getDocumentTooltip(
                            primaryEntityType,
                            isCWCOTProp,
                            isCWCOTCAProp,
                            isCABillProp
                          ) && (
                            <OverlayTrigger
                              placement="right"
                              overlay={(props) => (
                                <Tooltip
                                  {...props}
                                  className="document-upload-custom-tooltip"
                                >
                                  <div>
                                    {getDocumentTooltip(
                                      primaryEntityType,
                                      isCWCOTProp,
                                      isCWCOTCAProp,
                                      isCABillProp
                                    )}
                                  </div>
                                </Tooltip>
                              )}
                            >
                              <span>
                                <BsInfoCircle
                                  className="ms-2 "
                                  style={{
                                    cursor: "pointer",
                                    color: "#95A9BD",
                                    fontSize: "26px",
                                    background: "#EDF5FD",
                                    borderRadius: "50%",
                                  }}
                                />
                              </span>
                            </OverlayTrigger>
                          )}

                          <span className="text-danger"></span>
                        </Form.Label>
                        <Col sm="6">
                          <button
                            className="uploadCTA"
                            onClick={(e) => {
                              e.preventDefault();
                              primaryFileInputRef.current?.click();
                            }}
                            disabled={
                              isUploadingPrimary ||
                              isDeletingPrimary ||
                              shouldDisablePrimaryUpload
                            }
                          >
                            {isUploadingPrimary ? "Uploading..." : "Browse"}
                          </button>

                          <input
                            type="file"
                            multiple
                            ref={primaryFileInputRef}
                            style={{ display: "none" }}
                            accept=".pdf, .jpg, .jpeg"
                            onChange={(e) => handleFileChange(e, false)}
                          />
                        </Col>
                      </Form.Group>
                      <p className="cifTxt">
                        File formats accepted: pdf, jpg and jpeg. Maximum file
                        size allowed is 10MB.
                      </p>

                      {/* File Upload Status and Preview */}
                      {(isUploadingPrimary || isDeletingPrimary) && (
                        <div style={{ width: "100%", marginTop: "10px" }}>
                          <ShimmerTitle line={2} gap={10} variant="primary" />
                        </div>
                      )}

                      {!isUploadingPrimary &&
                        !isDeletingPrimary &&
                        uploadedFiles?.[getDocumnetsForbuyerCategory()]?.map(
                          (file, index) => (
                            <div
                              key={index}
                              className="mt-2 d-flex align-items-center justify-content-between"
                              style={{
                                border: "1px solid #D3EAFF",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                width: "80%",
                              }}
                            >
                              <small
                                style={{
                                  wordBreak: "break-all",
                                  marginRight: "16px",
                                  cursor: "pointer",
                                  color: "#208EF0",
                                  fontSize: "16px",
                                  fontFamily: "graphikmedium",
                                }}
                                onClick={() => handleFileDownload(file)}
                              >
                                {file.fileName}
                              </small>
                              <Button
                                variant="link"
                                onClick={(e) =>
                                  handleFileDelete(e, false, index)
                                }
                                disabled={
                                  isDeletingPrimary ||
                                  isUploadingPrimary ||
                                  !isStateWorkflowDurationActive
                                }
                                style={{
                                  textDecoration: "none",
                                  color: "#f25d49",
                                  padding: "0",
                                  marginLeft: "16px",
                                  fontSize: "16px",
                                  fontFamily: "graphikmedium",
                                }}
                              >
                                <i className="fas fa-times"></i> Remove
                              </Button>
                            </div>
                          )
                        )}
                      {errors?.primaryBuyer?.documents && (
                        <div className="text-danger mt-2">
                          <small>{errors.primaryBuyer.documents}</small>
                        </div>
                      )}

                      {/* General File Error Message */}
                      {fileError && (
                        <div className="text-danger mt-2">
                          <small>{fileError}</small>
                        </div>
                      )}
                    </Row>
                  )}
                </div>

                {/* Co-Buyer Section */}
                <div className="buyer-co-section mb-4">
                  <Form.Group as={Row} className="mb-3  align-items-center">
                    <Form.Label column sm="4" className="cifTxt">
                      Do you have a co-buyer?
                    </Form.Label>
                    <Col sm="9">
                      <div className="d-flex">
                        <Form.Check
                          type="radio"
                          id="cobuyer-yes"
                          label="Yes"
                          name="hasCobuyer"
                          value="yes"
                          checked={hasCobuyer === "yes"}
                          onChange={(e) => setHasCobuyer(e.target.value)}
                          className="me-3"
                        />
                        <Form.Check
                          type="radio"
                          id="cobuyer-no"
                          label="No"
                          name="hasCobuyer"
                          value="no"
                          checked={hasCobuyer === "no"}
                          onChange={(e) => setHasCobuyer(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Form.Group>

                  {hasCobuyer === "yes" && (
                    <div className="co-buyer-fields pt40">
                      <h3 style={{ color: "#383B42", fontSize: 24 }}>
                        CO-BUYER'S INFORMATION
                      </h3>
                      <div className="second_heading_info">
                        As this profile information will be used to bind legal
                        contract, please ensure to add information correctly.
                        Missing information and/ or inaccurate information can
                        cause the contract to be rejected.
                      </div>
                      <Form.Group as={Row} className="mb-3">
                        {/* Show entity type selection only for non-CWCOT properties */}
                        {!isCWCOTProp && !isCWCOTCAProp && !isCABillProp && (
                          <Form.Group as={Row} className="mb-3">
                            <Col sm="9" className="d-flex flex-column">
                              <div
                                className="my-3 cifTxt"
                                style={{ fontSize: 20 }}
                              >
                                Is the co-buyer a(n)
                              </div>
                              <div className="d-flex">
                                <Form.Check
                                  style={{ color: "#383B42" }}
                                  type="radio"
                                  id="cobuyer-individual"
                                  label="Individual"
                                  name="cobuyerEntityType"
                                  value="individual"
                                  checked={cobuyerEntityType === "individual"}
                                  onChange={(e) =>
                                    handleEntityTypeChange(e.target.value, true)
                                  }
                                  className="me-3"
                                />
                                <Form.Check
                                  style={{ color: "#383B42" }}
                                  type="radio"
                                  id="cobuyer-business"
                                  label="Business Entity"
                                  name="cobuyerEntityType"
                                  value="business"
                                  checked={cobuyerEntityType === "business"}
                                  onChange={(e) =>
                                    handleEntityTypeChange(e.target.value, true)
                                  }
                                />
                              </div>
                            </Col>
                          </Form.Group>
                        )}
                      </Form.Group>

                      {/* Co-Buyer Fields */}
                      <Row className="mb-3">
                        {/* For CWCOT/CWCOT-CA, always use buyerFields without entity type */}
                        {(isCWCOTProp || isCWCOTCAProp || isCABillProp
                          ? buyerFields
                          : cobuyerEntityType === "individual"
                          ? buyerFields
                          : businessFields
                        ).map((field, index) => (
                          <Form.Group
                            as={Col}
                            md={6}
                            className="mb-3"
                            key={`cobuyer-${index}`}
                          >
                            <p>
                              {field.label}
                              {field.required && (
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                              )}
                            </p>
                            <Col sm="9">
                              {field.type === "select" ? (
                                <>
                                  <Form.Select
                                    ref={(el) =>
                                      (cobuyerFormRef.current[field.name] = el)
                                    }
                                    name={field.name}
                                    value={
                                      field.name === "phone"
                                        ? formatPhoneNumber(
                                            cobuyerData[field?.name] || ""
                                          )
                                        : cobuyerData[field?.name] || ""
                                    }
                                    // value={cobuyerData[field.name] || ""}
                                    // onChange={(e) => {
                                    //   if (field.name === "phone") {
                                    //     const value = e.target.value;
                                    //     if (/^\d*$/.test(value) && value.length <= 10) {
                                    //       handleCobuyerChange(e);
                                    //     }
                                    //   } if (field.name === "zip") {
                                    //     const value = e.target.value;
                                    //     if (/^\d*$/.test(value) && value.length <= 5) {
                                    //       handleCobuyerChange(e);
                                    //     }
                                    //   }
                                    //   else {
                                    //     handleCobuyerChange(e)
                                    //   }
                                    // }
                                    // }
                                    onChange={(e) => {
                                      const { name, value } = e.target;

                                      if (
                                        (name === "zip" &&
                                          /^\d*$/.test(value) &&
                                          value.length <= 5) ||
                                        name !== "zip"
                                      ) {
                                        handleCobuyerChange(e);
                                      }
                                    }}
                                    onBlur={handleCobuyerValidationOnBlur}
                                    required={field.required}
                                    isInvalid={!!errors?.coBuyer?.[field.name]}
                                    className="py-3 "
                                  >
                                    <option value="">
                                      Select {field.label}
                                    </option>
                                    {states.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  {errors?.coBuyer?.[field.name] && (
                                    <Form.Control.Feedback type="invalid">
                                      {errors.coBuyer[field.name]}
                                    </Form.Control.Feedback>
                                  )}
                                </>
                              ) : (
                                <div>
                                  <Form.Control
                                    ref={(el) =>
                                      (cobuyerFormRef.current[field.name] = el)
                                    }
                                    type={field.type}
                                    placeholder={field.placeholder}
                                    name={field.name}
                                    value={
                                      field.name === "phone"
                                        ? formatPhoneNumber(
                                            cobuyerData[field?.name] || ""
                                          )
                                        : cobuyerData[field?.name] || ""
                                    }
                                    // value={cobuyerData[field.name] || ""}
                                    // onChange={(e) => {
                                    //   if (field.name === "phone") {
                                    //     const value = e.target.value;
                                    //     if (/^\d*$/.test(value) && value.length <= 10) {
                                    //       handleCobuyerChange(e);
                                    //     }
                                    //   } if (field.name === "zip") {
                                    //     const value = e.target.value;
                                    //     if (/^\d*$/.test(value) && value.length <= 5) {
                                    //       handleCobuyerChange(e);
                                    //     }
                                    //   }
                                    //   else {
                                    //     handleCobuyerChange(e)
                                    //   }
                                    // }
                                    // }
                                    onChange={(e) => {
                                      const { name, value } = e.target;
                                      if (
                                        (name === "zip" &&
                                          /^\d*$/.test(value) &&
                                          value.length <= 5) ||
                                        name !== "zip"
                                      ) {
                                        handleCobuyerChange(e);
                                      }
                                    }}
                                    onBlur={handleCobuyerValidationOnBlur}
                                    required={field.required}
                                    isInvalid={!!errors?.coBuyer?.[field.name]}
                                    className="bg-bid-in"
                                    maxLength={field.maxLength}
                                  />
                                  {/* {errors?.coBuyer?.[field.name] && (
                                    <Form.Control.Feedback type="invalid">
                                      {errors.coBuyer[field.name]}
                                    </Form.Control.Feedback>
                                  )} */}
                                  {errors?.coBuyer?.[field.name] && (
                                    <Form.Control.Feedback type="invalid">
                                      {field.name === "address1" &&
                                      cobuyerEntityType === "business"
                                        ? "Invalid corporation address"
                                        : errors.coBuyer[field.name]}
                                    </Form.Control.Feedback>
                                  )}

                                  {field.name === "city" &&
                                    showSuggestions &&
                                    citySuggestions.length > 0 && (
                                      <div className="suggestions-container-bid">
                                        {citySuggestions.map(
                                          (suggestion, index) => (
                                            <div
                                              key={index}
                                              className="suggestion-item"
                                              onClick={() =>
                                                handleSuggestionClick(
                                                  suggestion,
                                                  true
                                                )
                                              }
                                            >
                                              {suggestion}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )}
                                </div>
                              )}
                            </Col>
                          </Form.Group>
                        ))}
                      </Row>

                      {/* Document Upload Section - Only show for non-CWCOT business entity */}
                      {!isCWCOTProp &&
                        !isCWCOTCAProp &&
                        !isCABillProp &&
                        cobuyerEntityType === "business" &&
                        formState?.llc === "Required" && (
                          <Row>
                            <p>
                              Please upload Co-Buyer Business Entity formation
                              documents here (E.g.: LLC - Certificate of
                              Formation, Corporation - Articles of
                              Incorporation, LP - Certificate of Limited
                              Partnership, etc.)
                            </p>
                            <Form.Group
                              as={Col}
                              className="mb-3 d-flex align-items-center justify-content-center flex-column p-5"
                              style={{ border: "2px dotted #C5E3FF" }}
                            >
                              <Form.Label className="text-center mb-2 d-flex align-items-center justify-content-around">
                                <span
                                  style={{
                                    color: "#33333",
                                    fontSize: "26px",
                                    fontWeight: "500",
                                    letterSpacing: "0",
                                    lineHeight: "29px",
                                    textAlign: "center",
                                    fontFamily: "graphikmedium",
                                  }}
                                >
                                  Upload Co-Buyer Business Entity Formation
                                  Documents
                                </span>

                                <OverlayTrigger
                                  placement="right"
                                  overlay={(props) => (
                                    <Tooltip
                                      {...props}
                                      className="document-upload-custom-tooltip"
                                    >
                                      If a legal entity is purchasing the
                                      property, please upload the formation
                                      documents for that entity stamped as filed
                                      with the relevant state agency (typically
                                      the office of the Secretary of State where
                                      the entity was formed). Examples of
                                      acceptable documents include stamped
                                      copies of: the Articles of Incorporation
                                      of a corporation, Certificate of Formation
                                      for a LLC, Certificate of Limited
                                      Partnership for a LP.
                                    </Tooltip>
                                  )}
                                >
                                  <span>
                                    <BsInfoCircle
                                      className="ms-2 "
                                      style={{
                                        cursor: "pointer",
                                        color: "#95A9BD",
                                        fontSize: "20px",
                                        background: "#EDF5FD",
                                      }}
                                    />
                                  </span>
                                </OverlayTrigger>
                                <span className="text-danger"></span>
                              </Form.Label>

                              <button
                                className="uploadCTA m-0"
                                onClick={(e) => {
                                  e.preventDefault();
                                  coBuyerFileInputRef.current?.click();
                                }}
                                disabled={isUploadingCo || isDeletingCo}
                              >
                                {isUploadingCo ? "Uploading..." : "Browse"}
                              </button>

                              <input
                                type="file"
                                multiple
                                name="documents"
                                ref={coBuyerFileInputRef}
                                style={{ display: "none" }}
                                required={!uploadedFiles.coBuyer}
                                accept=".pdf, .jpg, .jpeg"
                                onChange={(e) => handleFileChange(e, true)}
                                disabled={isUploadingCo || isDeletingCo}
                              />
                              {/* <Col sm="6">
                                <Form.Control
                                  type="file"
                                  name="documents"
                                  onChange={(e) => handleFileChange(e, true)}
                                  ref={coBuyerFileInputRef}
                                  required={!uploadedFiles.coBuyer}
                                  accept=".pdf,.doc,.docx,.jpg,.jpeg"
                                  disabled={isUploadingCo || isDeletingCo}
                                />
                              </Col> */}
                            </Form.Group>
                            <p className="cifTxt">
                              File formats accepted: pdf, jpg and jpeg. Maximum
                              file size allowed is 10MB.
                            </p>

                            {/* Co-Buyer Upload Status */}
                            {(isUploadingCo || isDeletingCo) && (
                              <div style={{ width: "100%", marginTop: "10px" }}>
                                <ShimmerTitle
                                  line={2}
                                  gap={10}
                                  variant="primary"
                                />
                              </div>
                            )}

                            {/* Co-Buyer File Details */}
                            {!isUploadingCo &&
                              !isDeletingCo &&
                              uploadedFiles.coBuyer?.map((file, index) => (
                                <div
                                  key={index}
                                  className="mt-2 d-flex align-items-center justify-content-between"
                                  style={{
                                    border: "1px solid #D3EAFF",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff",
                                    width: "80%",
                                  }}
                                >
                                  <small
                                    style={{
                                      wordBreak: "break-all",
                                      marginRight: "16px",
                                      color: "#208EF0", // Added this
                                      fontSize: "16px",
                                      fontFamily: "graphikmedium",
                                    }}
                                  >
                                    {file.fileName}
                                  </small>
                                  <Button
                                    variant="link"
                                    onClick={(e) =>
                                      handleFileDelete(e, true, index)
                                    }
                                    disabled={isDeletingCo || isUploadingCo}
                                    style={{
                                      textDecoration: "none",
                                      color: "#f25d49",
                                      padding: "0",
                                      marginLeft: "16px",
                                      fontSize: "16px",
                                      fontFamily: "graphikmedium",
                                    }}
                                  >
                                    <i className="fas fa-times"></i> Remove
                                  </Button>
                                </div>
                              ))}
                            {/* Co-Buyer Error Messages */}
                            {(errors?.coBuyer?.documents ||
                              errors?.coBuyerDocuments) && (
                              <div className="text-danger mt-2">
                                <small>
                                  {errors?.coBuyer?.documents ||
                                    errors?.coBuyerDocuments}
                                </small>
                              </div>
                            )}
                          </Row>
                        )}
                      {/* General File Error Message */}
                      {fileError && (
                        <div className="text-danger mt-2">
                          <small>{fileError}</small>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* Add Shimmer Effect before error messages */}
                {isValidating && (
                  <div className="mb-3">
                    <ShimmerText line={3} gap={10} />
                  </div>
                )}
                {/* Error Messages */}
                {errors.primaryAddress && (
                  <div className="alert alert-danger">
                    {errors.primaryAddress}
                  </div>
                )}
                {errors.coAddress && (
                  <div className="alert alert-danger">{errors.coAddress}</div>
                )}

                {/* Submit Button */}
                <div className="d-flex justify-content-start">
                  <Button
                    type="submit"
                    variant="primary"
                    disabled={isValidating}
                    onClick={handleSubmit}
                    className="continueCTA"
                  >
                    {isValidating ? "Validating..." : "Continue"}
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </div>
      </div>
      {/* {showVerifyModal && (
        <VerifyPhoneModal
          handleClose={handleClose}
          show={showVerifyModal}
          phoneNumber={primaryBuyerData.phone}
        />
      )} */}
      {showVerifyModal && (
        <VerifyPhoneModal
          handleClose={handleClose}
          show={showVerifyModal}
          phoneNumber={primaryBuyerData.phone}
          onVerificationSuccess={handleVerificationSuccess}
        />
      )}
    </div>
  );
};

export default EditBuyer;
